import React from "react";
import GlyphIcon from "./GlyphIcon";
import { getServiceInitial } from "../appleTvPosterMeta";

// Small inline "where to watch" marker for hero meta lines: a tiny streaming
// logo, or the popcorn (theaters) / shopping-bag (buy) glyph. Sits at the
// start of the "Movie · Genre · Year …" line rather than beside the title.
export default function ServiceMark({ badge, className = "", featuredCard = false }) {
  if (!badge) return null;
  const { iconUrl, label, kind } = badge;
  const cls = `apple-clone__meta-service${className ? ` ${className}` : ""}`;
  if (iconUrl) {
    return (
      <span
        className={`${cls}${featuredCard ? " apple-clone__meta-service--logo" : ""}`}
        title={label}
      >
        <img src={iconUrl} alt={label} loading="lazy" decoding="async" />
      </span>
    );
  }
  if (featuredCard && kind === "buy") {
    return (
      <span className={`${cls} apple-clone__meta-service--buy-round`} title={label} aria-label={label}>
        <GlyphIcon name="bag" />
      </span>
    );
  }
  if (featuredCard && kind === "theaters") {
    return (
      <span className={`${cls} apple-clone__meta-service--theaters-round`} title={label} aria-label={label}>
        <GlyphIcon name="popcorn" />
      </span>
    );
  }
  if (kind === "streaming") {
    return (
      <span className={`${cls} apple-clone__meta-service--initial`} title={label} aria-label={label}>
        {getServiceInitial(label)}
      </span>
    );
  }
  return (
    <span className={`${cls} apple-clone__meta-service--glyph`} title={label}>
      <GlyphIcon name={kind === "theaters" ? "popcorn" : "bag"} title={label} />
    </span>
  );
}
